<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Entidades pensionarias</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative">

          <div class="w-full w-md-auto md-flex-1">
            <div class="d-flex justify-content-between align-items-center justify-content-lg-start">
              <div class="d-md-none">
                <button type="button" class="button-tooltip text-dark font-weight-bold m-0"
                  v-b-tooltip.hover title="Recargar" @click="loadData()">
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
            <div class="d-none d-md-flex">
              <button type="button" class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover title="Recargar" @click="loadData()">
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por nombre"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />
              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'pension-entity-create' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                >Agregar</b-button>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div><span>Nombre</span></div>
            <div><span>Estado</span></div>
          </section>
          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in filteredList" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div><span>{{ o.name }}</span></div>
                <div>
                  <span :class="`badge ${getStatus(o.status).color}`">{{ getStatus(o.status).label }}</span>
                </div>
                <div>
                  <button type="button" class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData">
                    <i :class="o.showMobileData ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                  </button>
                </div>
              </div>
              <div v-if="o.showMobileData" class="pt-3">
                <ul class="list-unstyled p-0">
                  <li><span class="font-weight-medium mr-2">Código:</span>{{ o.code }}</li>
                  <li><span class="font-weight-medium mr-2">Tipo:</span>{{ o.type }}</li>
                  <li><span class="font-weight-medium mr-2">Aporte oblig.:</span>{{ formatRate(o.mandatoryContributionRate) }}</li>
                </ul>
              </div>
              <div class="custom-table-mobile-options mt-3">
                <router-link :to="{ name: 'pension-entity-edit', params: { id: o.id } }" class="mx-3">Editar</router-link>
                <a href="" @click.prevent="openChangeStatus(o)">{{ getStatus(o.status).action }}</a>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>NOMBRE</th>
              <th>CÓDIGO</th>
              <th>TIPO</th>
              <th class="text-right">APORTE OBLIG.</th>
              <th class="text-right">PRIMA SEGURO</th>
              <th class="text-right">COM. FLUJO</th>
              <th class="text-right">COM. MIXTA</th>
              <th>ESTADO</th>
              <th class="pr-md-3">OPCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="filteredList.length === 0">
              <td colspan="9" class="text-center text-muted py-4">No se encontraron resultados.</td>
            </tr>
            <tr v-for="o in filteredList" :key="o.id">
              <td class="pl-3">{{ o.name }}</td>
              <td class="pl-3">{{ o.code }}</td>
              <td class="pl-3">
                <span :class="['badge', o.type === 'AFP' ? 'badge-info' : 'badge-secondary']">{{ o.type }}</span>
              </td>
              <td class="text-right pr-3">{{ formatRate(o.mandatoryContributionRate) }}</td>
              <td class="text-right pr-3">{{ o.type === 'AFP' ? formatRate(o.insurancePremiumRate) : '-' }}</td>
              <td class="text-right pr-3">{{ o.type === 'AFP' ? formatRate(o.flowCommissionRate) : '-' }}</td>
              <td class="text-right pr-3">{{ o.type === 'AFP' ? formatRate(o.mixedCommissionRate) : '-' }}</td>
              <td class="cell-center pl-md-2">
                <span :class="`badge ${getStatus(o.status).color}`">{{ getStatus(o.status).label }}</span>
              </td>
              <td class="cell-center d_option pr-md-2 position-relative">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      text="Editar"
                      :to="{ name: 'pension-entity-edit', params: { id: o.id } }"
                    />
                    <DropdownItem
                      :text="getStatus(o.status).action"
                      @click="openChangeStatus(o)"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-footer d-flex justify-content-end align-items-center">
        <div class="table-no-results" v-if="filteredList.length === 0">
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
        <p v-else class="m-0 px-3 text-muted small">{{ filteredList.length }} registro(s)</p>
      </div>
    </div>

    <ConfirmationModal
      :show="confirmationModal.show"
      @hide="closeConfirmationModal"
      :data="confirmationModal"
      @confirm="confirmModal"
    />
  </div>
</template>

<script>
import {
  Util,
  Alert,
  DropdownTable,
  DropdownItem,
  SearchBar,
  ConfirmationModal,
  ConfirmationModalMixin,
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";
import { PensionEntityService } from "@/core/services";

export default {
  mixins: [ConfirmationModalMixin],
  components: { DropdownTable, DropdownItem, SearchBar, ConfirmationModal },

  data() {
    return {
      list:   [],
      search: "",
    };
  },

  computed: {
    filteredList() {
      if (!this.search) return this.list;
      const q = this.search.toLowerCase();
      return this.list.filter((o) =>
        (o.name || "").toLowerCase().includes(q) ||
        (o.code || "").toLowerCase().includes(q)
      );
    },
  },

  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const resp = await PensionEntityService.list();
        this.list = (resp.payload || []).map((item) => ({
          ...item,
          showMobileData: false,
        }));
      } catch (e) {
        console.error(e);
        Alert.error(e.errors ? e.errors.message : "Error al cargar las entidades");
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },

    onSearch(val) {
      this.search = val;
    },

    getStatus(key) {
      return Util.searchValue(parseInt(key), LocalConstants.PensionEntityStatus);
    },

    formatRate(val) {
      if (val === null || val === undefined) return "-";
      return (val * 100).toFixed(2) + "%";
    },

    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title:       "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado de esta entidad?",
        acceptText:  "Aceptar",
        action:      "update",
      });
    },

    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "update") this.changeStatus();
    },

    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);
        const current    = parseInt(this.selectedOption.status);
        const newStatus  =
          current === LocalConstants.PensionEntityStatus.ACTIVE.key
            ? LocalConstants.PensionEntityStatus.INACTIVE.key
            : LocalConstants.PensionEntityStatus.ACTIVE.key;
        await PensionEntityService.changeStatus(this.selectedOption.id, newStatus);
        await this.loadData();
        Alert.success("Estado actualizado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors ? ex.errors.message : "Error al cambiar el estado");
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
  },

  async created() {
    await this.loadData();
  },
};
</script>

<style lang="stylus">
@import '../../Areas/Styles/supplier-list';
</style>
